/* global System */

export default {
  ButtonWithModalForm: () =>
    System.import(/* webpackChunkName: "Button" */ './index'),
}
